import QRCodeStyling from "qr-code-styling";
import { useEffect, useRef } from "react";

const qrCode = new QRCodeStyling({
  width: 240,
  height: 240,
  dotsOptions: {
    color: "#222",
    type: "dots",
  },
  cornersDotOptions: {
    type: "rounded",
    color: "#222",
  },
  cornersSquareOptions: {
    type: "extra-rounded",
    color: "#222",
  },
  qrOptions: {
    errorCorrectionLevel: "Q",
  },
  type: "svg",
});

export const QRCode = ({ url }: { url: string }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (ref?.current) {
      qrCode.append(ref.current);
    }
  }, [ref]);

  useEffect(() => {
    qrCode.update({
      data: url,
    });
  }, [url]);

  return <div ref={ref} />;
};
